import Vue from 'vue';
import Vuex from 'vuex';
import { mutations } from './mutations';
import actions from './actions';
import { getters, globalState } from './globalState';

Vue.use(Vuex);

export const globalStore = new Vuex.Store({
  state: globalState,
  getters,
  actions,
  mutations,
});
